@for (resolvedAction of resolvedActions; track resolvedAction.action.name; let last = $last) {
  @if (resolvedAction.action.mode === ActionMode.Navigate) {
    <a class="link-primary"
       [routerLink]="resolvedAction.routerLink"
       target="_blank"
       translate>{{ resolvedAction.action.actionName }}
    </a>
  } @else {
    <a role='button'
       class="link-primary border-0 bg-transparent"
       (click)="this.triggerAction(resolvedAction.action.name)"
       translate>{{ resolvedAction.action.actionName }}
    </a>
  }
  {{ last ? '' : ' | ' }}
}
